import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiAlertCircle, FiClock } = FiIcons;

const ProblemSection = () => {
  const problems = [
    {
      icon: FiX,
      title: "Cookie-cutter packages",
      description: "Generic trips that don't match your unique style"
    },
    {
      icon: FiAlertCircle,
      title: "Travel headaches",
      description: "Endless research, booking errors, and stress"
    },
    {
      icon: FiClock,
      title: "Wasted time",
      description: "Hours spent comparing options instead of enjoying life"
    }
  ];

  return (
    <section className="py-16 relative bg-gradient-to-br from-black to-gray-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="backdrop-blur-xl bg-black/60 rounded-3xl p-8 sm:p-12 border border-red-500/30 shadow-2xl text-center"
        >
          <motion.h2 
            className="text-3xl sm:text-4xl font-bold text-white mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            Tired of <span className="text-red-400">cookie-cutter vacations</span> and travel headaches?
          </motion.h2>
          
          <motion.p 
            className="text-xl text-gray-200 mb-10 max-w-4xl mx-auto leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            You deserve more than just another "package deal." Don't waste hours sifting through endless options or risk missing out on hidden gems. Whether you're planning a romantic escape, a family adventure, or a business trip, SeetaLuxuryEscape takes care of every detail—so you can focus on making memories.
          </motion.p>

          <div className="grid md:grid-cols-3 gap-6 mt-12">
            {problems.map((problem, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.6 + index * 0.1 }}
                viewport={{ once: true }}
                className="backdrop-blur-xl bg-red-900/30 rounded-2xl p-6 border border-red-500/40 hover:border-red-400/60 transition-all duration-300"
              >
                <SafeIcon icon={problem.icon} className="text-red-400 text-3xl mb-4 mx-auto" />
                <h3 className="text-white font-semibold text-lg mb-2">{problem.title}</h3>
                <p className="text-gray-300">{problem.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ProblemSection;